namespace GeniuzPOS.Purchase {
    export class PoCreditNoteAppColumns {
        static columnsKey = 'Purchase.PoCreditNoteApp';
    }
}
